import React from 'react';
import './About.css';
import ContactUs from './ContactUs.JPG';
import Logo from './logo.png';
import { Button } from '@material-ui/core';
import Footer from './Footer';

function About() {
  return (
    <div className='about_page'>
      <div className='app_header'>
        <Button href='/' style={{ backgroundColor: 'transparent' }}>
          <img className='app_headerImage' src={Logo} alt='' />
        </Button>
      </div>

      <div className='aboutintro'>
        <center>
          {' '}
          <img className='aboutbanner' src={ContactUs} alt='' />
        </center>
      </div>

      <div>
        <Footer />
      </div>
    </div>
  );
}

export default About;
